import { createApp } from 'vue'
import CubeCalculator from './CubeCalculator.vue'
import './assets/global.css'

createApp(CubeCalculator).mount('#cube')
